import { createSlice } from "@reduxjs/toolkit"

export const searchBarValueSlice = createSlice({
  name: "searchBarValue",
  initialState: "",
  reducers: {
    setSearchBarValue: (_state, action) => {
      return action.payload
    },
  },
})

export const { setSearchBarValue } = searchBarValueSlice.actions

export default searchBarValueSlice.reducer
